import React from 'react';
import { User, Bell, CreditCard, Heart, Gear, SignOut } from '@phosphor-icons/react';
import BottomNav from '../components/BottomNav';
import PushToggleCard from '../components/PushToggleCard';
import { useAuth } from '../context/AuthContext';

const ProfilePage = () => {
  const { user } = useAuth();
  const menuItems = [
    { icon: User, label: 'Edit Profile', badge: null },
    { icon: Bell, label: 'Notifications', badge: '3' },
    { icon: CreditCard, label: 'Payment Methods', badge: null },
    { icon: Heart, label: 'Saved Flights', badge: null },
    { icon: Gear, label: 'Settings', badge: null },
  ];

  return (
    <div className="min-h-screen bg-[#E7EEEE] pb-20">
      <div className="sticky top-0 z-30 bg-white/90 backdrop-blur-xl border-b border-gray-200 p-4">
        <h1 className="text-2xl font-bold text-[#1B375B]" style={{ fontFamily: 'Outfit, sans-serif' }}>
          Profile
        </h1>
      </div>
      
      <div className="p-4">
        {/* Profile Card */}
        <div className="bg-white rounded-2xl p-6 mb-4 shadow-sm border border-gray-200/50">
          <div className="flex items-center gap-4">
            <div className="w-16 h-16 rounded-full bg-gradient-to-br from-[#1B375B] to-[#659A9B] flex items-center justify-center">
              <User size={32} weight="fill" className="text-white" />
            </div>
            <div>
              <h2 className="text-lg font-bold text-[#1B375B]" style={{ fontFamily: 'Outfit, sans-serif' }}>
                Guest User
              </h2>
              <p className="text-sm text-gray-500" style={{ fontFamily: 'Manrope, sans-serif' }}>
                guest@acftourism.com
              </p>
            </div>
          </div>
        </div>

        {/* Push Notification Toggle */}
        <div className="mb-4">
          <PushToggleCard
            user_id={user?.id || null}
            user_type={user ? 'b2c' : 'guest'}
          />
        </div>

        {/* Menu Items */}
        <div className="bg-white rounded-2xl overflow-hidden shadow-sm border border-gray-200/50">
          {menuItems.map((item, index) => {
            const Icon = item.icon;
            return (
              <button
                key={item.label}
                className={`w-full flex items-center justify-between p-4 active:bg-gray-50 transition-colors ${
                  index !== menuItems.length - 1 ? 'border-b border-gray-100' : ''
                }`}
                style={{ minHeight: '44px' }}
              >
                <div className="flex items-center gap-3">
                  <div className="w-10 h-10 rounded-xl bg-[#659A9B]/10 flex items-center justify-center">
                    <Icon size={20} className="text-[#659A9B]" />
                  </div>
                  <span className="text-base font-medium text-[#1B375B]" style={{ fontFamily: 'Manrope, sans-serif' }}>
                    {item.label}
                  </span>
                </div>
                {item.badge && (
                  <span className="px-2 py-0.5 bg-red-500 text-white text-xs font-semibold rounded-full">
                    {item.badge}
                  </span>
                )}
              </button>
            );
          })}
        </div>

        {/* Logout Button */}
        <button className="w-full mt-4 bg-white rounded-2xl p-4 flex items-center justify-center gap-3 active:bg-gray-50 transition-colors shadow-sm border border-gray-200/50">
          <SignOut size={20} className="text-red-500" />
          <span className="text-base font-semibold text-red-500" style={{ fontFamily: 'Manrope, sans-serif' }}>
            Logout
          </span>
        </button>
      </div>
      
      <BottomNav />
    </div>
  );
};

export default ProfilePage;